import { SubscriptionStatus, SubscriptionTier } from '@heidi/schema/ml-scribe';

export type ReverseTrialCohort = 'clinician' | 'practice';

/**
 * Decide which post–reverse-trial cohort a user belongs to.
 *
 * Trial-end UIs branch their copy + plan name on this signal: solo Clinician
 * (PRO → Scribe Plus) vs Practice admin (PRO_PLUS → Scribe Team).
 *
 * Prefers the pre-trial status (`previous_status_before_clinician_trial`)
 * because the post-trial `userTier` is unreliable: IA-ended trials and
 * declined upgrades drop the user to FREE, which would otherwise
 * mis-route a Clinician account into the Practice copy. Falls back to
 * the current tier for legacy accounts without billing telemetry.
 */
export function getReverseTrialCohort({
  previousStatusBeforeClinicianTrial,
  userTier,
}: {
  previousStatusBeforeClinicianTrial: SubscriptionStatus | null | undefined;
  userTier: SubscriptionTier | undefined;
}): ReverseTrialCohort {
  if (previousStatusBeforeClinicianTrial != null) {
    const previousStatus = previousStatusBeforeClinicianTrial;
    if (
      previousStatus === SubscriptionStatus.PRO ||
      previousStatus === SubscriptionStatus.PRO_TRIAL ||
      previousStatus === SubscriptionStatus.FREE
    ) {
      return 'clinician';
    }
    if (
      previousStatus === SubscriptionStatus.PRO_PLUS_TRIAL ||
      previousStatus === SubscriptionStatus.PRO_PLUS
    ) {
      return 'practice';
    }
    return 'clinician';
  }
  // should default to clinician unless user tier is PRO_PLUS
  return userTier === SubscriptionTier.PRO_PLUS ? 'practice' : 'clinician';
}
